import React from 'react'
import Inputs from '../../components/Inputs'

const InputsContainer = () => <Inputs minimal={false}/>

export default InputsContainer